import ManageUserTable from './manageUserTable'

export default ManageUserTable
